import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CashmereModule } from '../cashmere.module';
import { ProductService } from './services/catalog.service';
import { SuiteService } from './services/suites.service';
import { TechnologyService } from './services/technology.service';
import { ServiceService } from './services/service.service';
import { PartnerService } from './services/partner.service';
import { UserService } from './services/user.service';
import { TemplateService } from './services/template.service';
import { ChangeService } from './services/change.service';
import { TerminologyService } from './services/terminology.service';
import { OktaService } from './services/okta.service';
import { DataSetService } from './services/dataset.service';
import { AppService } from './services/app.service';
import { DocumentService } from './services/document.service';
import { CanDeactivateGuard } from '../admin/can-deactivate/can-deactivate.guard';
import { TypeService } from './services/type.service';
import { ProductLineService } from './services/product-line.service';
import { StatusService } from './services/status.service';
import { SLAService } from './services/sla.service';
import { ItemService } from './services/item.service';
import { FilterPopoverComponent } from './filter-popover/filter-popover.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SanitizeHtmlPipe } from './sanitizeHtml.pipe';
import { TermChangeService } from './services/termChange.service';
import { DownloadService } from './services/download.service';
import { SourceService } from './services/source.service';
import { KeyService } from './services/key.service';

@NgModule({
    declarations: [FilterPopoverComponent, SanitizeHtmlPipe],
    imports: [CommonModule, CashmereModule, FormsModule, ReactiveFormsModule],
    exports: [
        FilterPopoverComponent,
        SanitizeHtmlPipe,
        CommonModule,
        CashmereModule
    ],
    providers: [
        ProductService,
        SuiteService,
        TechnologyService,
        ServiceService,
        PartnerService,
        UserService,
        TemplateService,
        ChangeService,
        TerminologyService,
        OktaService,
        AppService,
        DataSetService,
        DocumentService,
        CanDeactivateGuard,
        TypeService,
        ProductLineService,
        KeyService,
        StatusService,
        SLAService,
        ItemService,
        TermChangeService,
        DownloadService,
        SourceService
    ]
})
export class SharedModule { }
